/** POS-I267: the phone pages live under /m (or /m/...). */
export function isPhonePath(pathname: string): boolean {
  return pathname === '/m' || pathname.startsWith('/m/');
}
